import { DatePickerPreset } from './DatePicker.Preset/DatePicker.Preset.es.js';
import { DatePickerPresetRange } from './DatePicker.PresetRange/DatePicker.PresetRange.es.js';
import { DatePickerRange } from './DatePicker.Range/DatePicker.Range.es.js';
import { DatePickerSingle } from './DatePicker.Single/DatePicker.Single.es.js';

const DatePicker = DatePickerSingle;
DatePicker.Range = DatePickerRange;
DatePicker.Preset = DatePickerPreset;
DatePicker.PresetRange = DatePickerPresetRange;

export { DatePicker, DatePicker as default };
//# sourceMappingURL=DatePicker.es.js.map
